import { Clazz } from './clazz'
import { Student } from './student'

export enum VacationHomeworkReportScope {
  MyClazzes = 'myClazzes',
  AllClazzes = 'allClazzes',
  SingleClazz = 'singleClazz',
}

export interface IVacationHomeworkReportDates {
  school_item: {
    start_date: string
    end_date: string
  }
  own_classes_item: {
    start_date: string
    end_date: string
  }
  class_items: Array<{
    clazz: Clazz
    start_date: string
    end_date: string
  }>
}

export interface IVacationHomeworkReportSummary {
  grades: number
  classes: number
  students: number
  homework_participate_rate: number
  homework_finish_rate: number
  competition_participate_rate: number
  avg_duration: number
  avg_count: number
  calories: number
  rate_s_amount: number
  rate_a_amount: number
  rate_b_amount: number
  rate_c_amount: number
  rate_d_amount: number
  unfinish_amount: number
}

export interface IVacationHomeworkReportBase {
  summary: IVacationHomeworkReportSummary
  daily_homework_trend: Array<{
    date: string
    participate_rate: number
    finish_rate: number
  }>
  weekly_homework_trend: Array<{
    date: string
    participate_rate: number
    finish_rate: number
  }>
  competition_trend: Array<{
    date: string
    participate_rate: number
  }>
  excellent_classes: Array<{
    clazz: Clazz
    homework_participate_rate: number
    homework_finish_rate: number
    competition_participate_rate: number
  }>
  excellent_students_by_class: Array<{
    clazz: Clazz
    students: Student[]
  }>
  excellent_students: Student[]
  ranks: Array<{
    student: Student
    finish_days: number
    finish_rate: number
  }>
}
